/**
 * @generated SignedSource<<c099fa44113ed85cde855a7d6f183347>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "resellerPId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ResellerProgramDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteResellerProgramTPayload",
        "kind": "LinkedField",
        "name": "deleteResellerProgramTByResellerPId",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ResellerProgramT",
            "kind": "LinkedField",
            "name": "resellerProgramT",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ResellerProgramDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteResellerProgramTPayload",
        "kind": "LinkedField",
        "name": "deleteResellerProgramTByResellerPId",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ResellerProgramT",
            "kind": "LinkedField",
            "name": "resellerProgramT",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "nodeId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8ccde4e6488e96df2030c1e156d9b4fe",
    "id": null,
    "metadata": {},
    "name": "ResellerProgramDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation ResellerProgramDeleteMutation(\n  $input: DeleteResellerProgramTByResellerPIdInput!\n) {\n  deleteResellerProgramTByResellerPId(input: $input) {\n    resellerProgramT {\n      resellerPId\n      nodeId\n    }\n  }\n}\n"
  }
};
})();

node.hash = "21510c7a429592a534cf1fdb8d930a73";

module.exports = node;
